export const formatCurrencyRegisterVehicleForm = (inputString: string) => {
  if (!inputString || Number.isNaN(inputString)) {
    return '';
  }

  const numericValue = parseFloat(inputString.replace(/[^\d,]/g, ''));
  let newInputString = inputString.replace(
    /\d+/,
    Math.floor(numericValue).toLocaleString('pt-BR'),
  );

  return `R$ ${newInputString}`;
};
